import React, { useState } from "react";
import { Box, Button, Typography, Grid, useMediaQuery } from "@mui/material";
import {
  BGColor02,
  blackColor,
  blackShade05,
  blackShade19,
  blackShade58,
  blueColor04,
  descriptionColor,
  greenColor17,
  greyColor9,
  lightGreenColor05,
  mobilePrimary,
  orangeBgColor,
  orangeColor04,
  redColor,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import FormInputBoxWithBorder from "../../../components/Input/FormInputBoxWithBorder";
import PickLocationBtn from "../../../components/Buttons/PickLocationBtn";
import PickAddressFromMapModal from "../../../components/PickAddress/PickAddressFromMapModal";
import { getGeoPointApi } from "../../../service/api_calls/BusinessOnboard/BusinessOnboardingAPI";
import { isStringNotPresentInArray } from "../../../utils/helper";
import AddressPicker from "../../Dashboard/components/AddressPicker";

const MarkerIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="#1C1C1C"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    aria-labelledby="icon-svg-title- icon-svg-desc-"
    role="img"
    class="sc-rbbb40-0 haYhpV"
  >
    <title>loction-pin</title>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.50376 0.135614C5.50502 0.734541 3.10602 3.13025 2.60623 6.12488C2.00648 9.81826 4.00564 13.1123 7.10435 14.3102C8.10393 14.7095 9.00355 15.4082 9.50334 16.4064C9.70326 16.7059 9.80322 17.1052 10.0031 17.4047C10.1031 17.1052 10.303 16.7059 10.5029 16.4064C11.0027 15.4082 11.9023 14.8093 12.9019 14.3102C15.6008 13.2122 17.5 10.517 17.5 7.42255C17.5 2.9306 13.3018 -0.762775 8.50376 0.135614ZM10.0031 10.0179C8.60372 10.0179 7.50418 8.91987 7.50418 7.52237C7.50418 6.12488 8.60372 5.02685 10.0031 5.02685C11.4025 5.02685 12.5021 6.12488 12.5021 7.52237C12.5021 8.91987 11.4025 10.0179 10.0031 10.0179Z"
    ></path>
    <path
      fill="#10847e"
      d="M10.0033 20C11.1074 20 12.0025 19.5531 12.0025 19.0018C12.0025 18.4505 11.1074 18.0036 10.0033 18.0036C8.89921 18.0036 8.00415 18.4505 8.00415 19.0018C8.00415 19.5531 8.89921 20 10.0033 20Z"
    ></path>
  </svg>
);

function AddBranchPopup({
  businessName,
  data,
  setData,
  onValueChange,
  onCancel,
  onSubmit,
  loader,
}) {
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));

  const [openMap, setOpenMap] = useState({
    show: false,
    userLat: "",
    userLong: "",
  });

  const [cityDisabled, setCityDisabled] = useState(true);

  const [openAddressPicker, setOpenAddressPicker] = useState(false);

  // Get user current location address
  const handleChooseCurrentLocation = () => {
    setOpenMap({
      show: true,
      userLat: localStorage.getItem("lat"),
      userLong: localStorage.getItem("long"),
    });
  };

  const handlePinChange = async (value) => {
    if (value?.length === 6) {
      const responce = await getGeoPointApi(value);

      const pinCodeErr = isStringNotPresentInArray(
        responce?.results?.[0]?.address_components,
        "postal_code"
      );
      console.log("pinCodeErrpinCodeErr", pinCodeErr);
      if (pinCodeErr) {
        console.log("Hit");
        setData({
          ...data,
          pinCode: value,
          city: "",
          state: "",
          landmark: "",
          address: "",
          errors: {
            ...data?.errors,
            pinCode: "Invalid pincode",
          },
        });
        return;
      }

      const city = responce?.results?.[0]?.address_components?.[1]?.long_name;

      const state =
        responce?.results?.[0]?.address_components?.[
          responce?.results?.[0]?.address_components?.length - 2
        ]?.long_name;

      if (!city || !state) setCityDisabled(false);

      setData({
        ...data,
        city: city || "",
        state: state || "",
        landmark: "",
        locality: city || "",
        sublocality: "",
        lat: responce?.results?.[0]?.geometry?.location?.lat || "",
        lng: responce?.results?.[0]?.geometry?.location?.lng || "",
        pinCode: value,
        errors: { ...data?.errors, city: "", state: "", pinCode: "" },
      });

      setOpenMap({
        show: true,
        userLat: responce?.results?.[0]?.geometry?.location?.lat || "",
        userLong: responce?.results?.[0]?.geometry?.location?.lng || "",
      });
    }
  };

  // autoFill user selected address from map
  const handlePickLocationConfirm = (userAddress) => {
    if (userAddress) {
      setData({
        ...data,
        fullAddress: userAddress?.fullAddress || "",
        city: userAddress?.city || "",
        state: userAddress?.state || "",
        pinCode: userAddress?.postalCode,
        address: userAddress?.address || "",
        lat: userAddress?.lat || "",
        lng: userAddress?.lng || "",
        landmark: userAddress?.locality || "",
        locality: userAddress?.locality || "",
        sublocality: userAddress?.sublocality || "",
        errors: {
          ...data?.errors,
          city: "",
          state: "",
          pinCode: "",
          address: "",
        },
      });
    }

    // setOpenMap({
    //   show: false,
    //   userLat: "",
    //   userLong: "",
    // });
  };

  return (
    <Box sx={{ background: whiteColor, borderRadius: "10px" }}>
      <PickAddressFromMapModal
        isOpen={openMap.show}
        setIsOpen={setOpenMap}
        onConfirm={handlePickLocationConfirm}
        userLat={openMap.userLat}
        userLong={openMap.userLong}
      />

      {openAddressPicker && (
        <AddressPicker
          open={openAddressPicker}
          handleClose={() => setOpenAddressPicker(false)}
          addressDetails={data}
          handlePickLocationConfirm={handlePickLocationConfirm}
          onValueChange={(name, value) => {
            onValueChange(name, value);
          }}
        />
      )}

      <Box
        sx={{
          backgroundColor: BGColor02,
          p: "10px 15px",
          borderRadius: "10px 10px 0 0",
        }}
      >
        <Typography
          fontSize={17}
          fontWeight={600}
          color={blackShade19}
          textAlign={"center"}
          mb={0.5}
        >
          {businessName}
        </Typography>
        <Typography
          fontSize={13}
          fontWeight={500}
          color={greyColor9}
          textAlign={"center"}
        >
          Master Branch
        </Typography>
      </Box>
      <Box p={2} sx={styles.content}>
        <Grid container rowSpacing={0} columnSpacing={{ md: 3, xs: 2 }}>
          <Grid item xs={12} md={12}>
            <FormInputBoxWithBorder
              label="Branch Name"
              value={data?.branchName}
              onChange={({ target }) => {
                onValueChange("branchName", target.value);
              }}
              required
              maxLength={50}
              error={data?.errors?.branchName}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <FormInputBoxWithBorder
              label="Registered Business Name (as per GST, for invoicing)"
              value={data.registeredBusinessName}
              onChange={({ target }) => {
                onValueChange("registeredBusinessName", target.value);
              }}
              maxLength={100}
              error={data?.errors?.registeredBusinessName}
              required
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <FormInputBoxWithBorder
              label="GSTIN Number"
              value={data.gstNumber}
              onChange={({ target }) => {
                const value = target.value
                  .replace(/[^a-zA-Z0-9]/g, "")
                  .toUpperCase();

                if (value.length == 15) {
                  const reg =
                    /\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/.test(
                      value
                    );
                  console.log("reg", reg);
                  if (reg) {
                    setData({
                      ...data,
                      gstNumber: value,
                      panNumber: value.slice(2, 12),
                      errors: {},
                    });
                  } else {
                    setData({
                      ...data,
                      gstNumber: value,
                      errors: {
                        ...data?.errors,
                        gstNumber: "Please enter the valid GST Number.",
                      },
                    });
                  }
                } else {
                  onValueChange("gstNumber", value);
                }
              }}
              maxLength={15}
              error={data?.errors?.gstNumber}
              required
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <FormInputBoxWithBorder
              label="PAN Number"
              value={data?.panNumber}
              onChange={({ target }) => {
                const value = target.value
                  .replace(/[^a-zA-Z0-9]/g, "")
                  .toUpperCase();
                if (value.length == 10) {
                  const reg = /[A-Z]{5}\d{4}[A-Z]{1}/.test(value);
                  if (reg) {
                    setData({
                      ...data,
                      panNumber: value,
                      errors: {},
                    });
                  } else {
                    setData({
                      ...data,
                      panNumber: value,
                      errors: {
                        ...data?.errors,
                        panNumber: "Please enter the valid PAN Number.",
                      },
                    });
                  }
                } else {
                  onValueChange("panNumber", value);
                }
              }}
              maxLength={10}
              error={data?.errors?.panNumber}
              required
            />
          </Grid>
        </Grid>
        <Box
          display="flex"
          justifyContent="space-between"
          mb={0.5}
          mt={1}
          alignItems="center"
        >
          <Typography
            fontSize={14}
            fontWeight={600}
            color={blackShade19}
            textAlign={"start"}
          >
            Business Address Detail
          </Typography>
        </Box>

        <Grid container rowSpacing={{ md: 0.5, xs: 0 }} columnSpacing={3}>
          <Grid item xs={12} md={12}>
            {!data?.fullAddress ? (
              <Box my={1}>
                <PickLocationBtn
                  onChooseLocation={() => setOpenAddressPicker(true)}
                  onPickNearLocation={() => {
                    setOpenMap(true);
                  }}
                  bgColor={whiteColor}
                  textColor={matches ? blueColor04 : mobilePrimary}
                  btnText="ADD WAREHOUSE LOCATION"
                />
              </Box>
            ) : (
              <Box>
                <SelecteAddressInfo
                  // fullAddress={data?.fullAddress}
                  fullAddress={`${data?.address} ${
                      data?.landmark
                        ? `${data?.landmark},`
                        : ""
                    } ${data?.city}, ${data?.state} - ${
                      data?.pinCode
                    }`}
                  onChange={() => {
                    setOpenAddressPicker(true);
                  }}
                />

                <Box sx={styles.infoBox}>
                  <Typography
                    // textAlign={"center"}
                    fontWeight={{ xs: 500, md: 600 }}
                    fontSize={13}
                    color={blackShade58}
                    lineHeight={{ md: "21px", xs: "20px" }}
                  >
                    Please make sure the above address is accurate as the
                    deliveries will be picked up from this location
                  </Typography>
                </Box>

                <Box display="flex" justifyContent="flex-end" mt={1.5}>
                  <Button
                    variant="text"
                    sx={styles.pickLocationBtn}
                    onClick={() => setOpenAddressPicker(true)}
                  >
                    Edit Address/Pick New Location
                  </Button>
                </Box>
              </Box>
            )}

            {data?.errors?.address ? (
              <Typography
                variant="body1"
                component="p"
                fontSize={11.5}
                fontWeight={500}
                color='red'
              >
                Pick warehouse address
              </Typography>
            ) : null}
          </Grid>

          {/* <Grid item xs={12} md={4}>
            <FormInputBoxWithBorder
              label="PinCode"
              required
              maxLength={6}
              value={data?.pinCode}
              onChange={({ target }) => {
                const value = target.value.replace(/[a-zA-Z]|[^\w\s]/gi, "");
                onValueChange("pinCode", value);
                if (!cityDisabled) setCityDisabled(true);
                if (value.length >= 6) handlePinChange(value);
              }}
              error={data?.errors?.pinCode}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <FormInputBoxWithBorder
              label="City"
              value={data?.city}
              onChange={({ target }) => {
                onValueChange("city", target.value);
              }}
              required
              disabled={cityDisabled}
              inputOpaticy={1}
              error={data?.errors?.city}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <FormInputBoxWithBorder
              label="State"
              value={data?.state}
              onChange={({ target }) => {
                onValueChange("state", target.value);
              }}
              required
              disabled={cityDisabled}
              inputOpaticy={1}
              error={data?.errors?.state}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <FormInputBoxWithBorder
              label="Bldg No, Street, Area"
              value={data?.address}
              onChange={({ target }) => {
                onValueChange("address", target.value);
              }}
              error={data?.errors?.address}
              required
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <FormInputBoxWithBorder
              label="Landmark"
              value={data?.landmark}
              onChange={({ target }) => {
                onValueChange("landmark", target.value);
              }}
            />
          </Grid> */}
        </Grid>
        <Typography
          fontSize={14}
          fontWeight={600}
          color={blackShade19}
          textAlign={"start"}
          mt={1}
          mb={0.5}
        >
          Contact Detail
        </Typography>
        <Grid container rowSpacing={{ md: 0.5, xs: 0 }} columnSpacing={3}>
          <Grid item xs={12} md={6}>
            <FormInputBoxWithBorder
              label="Phone Number"
              required
              startIcon="+91"
              maxLength={10}
              value={data?.phoneNumber}
              onChange={({ target }) => {
                const number = target.value?.replace(/[^0-9]/g, "");
                onValueChange("phoneNumber", number);
              }}
              error={data?.errors?.phoneNumber}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormInputBoxWithBorder
              label="Email"
              required
              value={data?.email}
              onChange={({ target }) => {
                onValueChange("email", target.value);
              }}
              error={data?.errors?.email}
            />
          </Grid>
        </Grid>
        <Typography
          fontSize={13}
          fontWeight={500}
          color={blackShade19}
          textAlign={"center"}
          mt={1}
        >
          E-Commerce Settings and Active Catalog details will be copied over
          from the Master Branch
        </Typography>
        <Typography
          fontSize={13}
          fontWeight={500}
          color={blackShade19}
          textAlign={"center"}
          mt={1.5}
        >
          You will be able to switch the Super Admin and assign managers, once
          the branch is activated
        </Typography>
      </Box>
      <Box
        sx={{
          backgroundColor: BGColor02,
          p: "10px 15px",
          borderRadius: "0 0 10px 10px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Button
          sx={styles.cancelBtn}
          variant="contained"
          disableElevation
          onClick={onCancel}
          disabled={loader}
        >
          Cancel
        </Button>
        <Button
          sx={styles.submitBtn}
          variant="contained"
          disableElevation
          onClick={onSubmit}
          disabled={loader}
        >
          Add Branch
        </Button>
      </Box>
    </Box>
  );
}

export default AddBranchPopup;

const SelecteAddressInfo = ({ fullAddress, onChange }) => {
  return (
    <Box sx={styles.selectedAddrInfoBox}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={{ xs: "10px", md: "15px" }}
      >
        <Typography
          fontSize={{ xs: 13.5, md: 14 }}
          fontWeight={600}
          color={blackColor}
          lineHeight="15px"
          letterSpacing="-0.3px"
          mt={{ xs: 0, md: 0.5 }}
        >
          Selected Address
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: "9px",
          bgcolor: lightGreenColor05,
          p: "10px 8px",
          borderRadius: "6px",
        }}
      >
        <Box
          width={{ xs: "19px", md: "21px" }}
          height={{ xs: "19px", md: "21px" }}
          mt={-0.1}
        >
          <MarkerIcon />
        </Box>

        <Typography
          fontSize={{ xs: 11.5, md: 12.5 }}
          fontWeight={600}
          color={greenColor17}
          lineHeight="18px"
          letterSpacing="0px"
        >
          {fullAddress}
        </Typography>
      </Box>
    </Box>
  );
};

const styles = {
  content: {
    maxHeight: "70vh",
    overflow: "auto",
    "&::-webkit-scrollbar": {
      width: "4px",
      height: "4px",
      borderRadius: "50px !important",
    },
    "&::-webkit-scrollbar-thumb": {
      // background: '#d0d3da',
      background: "rgba(0,0,0,0.1)",
    },
    "&::-webkit-scrollbar-track": {
      background: "rgba(0,0,0,0.05)",
    },
  },
  submitBtn: {
    padding: "5px 16px",
    width: { md: "auto", xs: "90%" },
    fontSize: "12.5px",
    fontWeight: 600,
    backgroundColor: blueColor04,
    color: whiteColor,
    border: "1px solid " + blueColor04,
    "&:hover": {
      backgroundColor: whiteColor,
      color: blueColor04,
    },

    "&.Mui-disabled": {
      border: "none",
    },
  },
  cancelBtn: {
    padding: "5px 16px",
    width: { md: "auto", xs: "90%" },
    fontSize: "12.5px",
    fontWeight: 600,
    color: blackShade19,
    backgroundColor: whiteColor,
    border: "1px solid " + blackShade19,
    "&:hover": {
      color: whiteColor,
      backgroundColor: blackShade19,
    },

    "&.Mui-disabled": {
      border: "none",
    },
  },

  selectedAddrInfoBox: {
    bgcolor: whiteColor,
    mb: { xs: 0, md: 2 },
  },

  addLocationBtn: {
    fontSize: 12,
    fontWeight: 600,
    lineHeight: "15px",
    color: orangeColor04,
    textDecoration: "underline",
    textTransform: "uppercase",
    "&:hover": {
      color: orangeColor04,
      bgcolor: "transparent",
    },
  },

  pickLocationBtn: {
    fontSize: 11.5,
    fontWeight: 600,
    lineHeight: "15px",
    color: orangeColor04,
    textDecoration: "underline",
    textTransform: "uppercase",
    "&:hover": {
      color: orangeColor04,
      bgcolor: "transparent",
    },
  },

  infoBox: {
    px: 1,
    py: 1,
    borderRadius: "7px",
    backgroundColor: orangeBgColor,
    mt: { xs: 2, md: 0 },
  },
};
